<template>
  <div class="notice_page">
    <!-- 顶部公告标签 -->
    <div class="tabs">
      <ul id="head">
        <li
          v-for="(item, index) in tabHeadList"
          :key="item.id"
          class="tab_item"
          @click="changeTab(item, index)"
        >
          <div v-if="item.unreadCount > 0" class="flex_">
            <div :class="{ on_: index == tabActive }" class="text_tab">
              <p style="white-space: nowrap">{{ item.name }}</p>
              <span :class="{ bcicle_: index == tabActive }"></span>
            </div>
            <span
              :class="item.unreadCount < 10 ? 'dot1' : 'dot2'"
              v-if="item.unreadCount > 0"
              >{{ item.unreadCount <= 99 ? item.unreadCount : "99+" }}</span
            >
          </div>
          <template v-else>
            <div class="flex_">
              <div class="text_tab">
                <p style="white-space: nowrap">{{ item.name }}</p>
                <span :class="{ bcicle_: index == tabActive }"></span>
              </div>
            </div>
          </template>
        </li>
      </ul>
      <div class="clear_all" @click="clearAllUnread">
        <div class="inner">
          <img src="../../../../assets/image/bs-2.0/clear_all.webp" alt="">
          <span>清除未读</span>
        </div>
      </div>
    </div>
    <!-- 公告列表 -->
    <div class="pro_list">
      <div v-for="pro in proList" :key="pro.id" @click="goProDetail(pro)">
        <div class="pro_item van-clearfix">
          <p class="title_">
            <span
              v-if="
                bsMall ? Number(pro.sort || 0) > 1 : Number(pro.sort || 0) >= 1
              "
              class="top"
            ></span>
            <span class="title-txt">{{ pro.noticeTitle }}</span>
            <span class="dot_" v-if="pro.isRead != 'Y'"></span>
          </p>
          <p class="desc_">
            <span class="content_txt"></span>
            <span class="time_"
              >创建时间：{{ pro.createDate | filterTime }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="nomore" v-if="finished">没有更多了~</div>
    <div class="modal-content-div" v-show="showRichTextMadal">
      <div class="inner-div">
        <div class="title">{{ noticeTitle }}</div>
        <div class="content" v-html="richTextContent"></div>
        <div class="close" @click.stop="showRichTextMadal = false">X</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
export default {
  data() {
    return {
      tabHeadList: [], // 公告标签
      proList: [], // 公告列表
      tabActive: 0, // 激活的标签
      noticeType: "", // 公告类型
      finished: false, // 是否结束查询
      userId: "", // 用户id
      mainId: "", // 商城id
      pages: 1,
      pagination: {
        // 分页
        pageNum: 1,
        pageSize: 10,
      },
      showRichTextMadal: false, // 显示富文本弹窗
      richTextContent: "", // 富文本内容
      noticeTitle: "", // 公告标题
    };
  },
  computed: {
    bsMall() {
      return ["1048", "1013"].includes(this.mainId);
    },
  },
  created() {
    this.userId = this.$route.query.userId;
    this.mainId = this.$route.query.coreWxMainId;
    this.getNoticeReadRecord();
    this.queryLabelList();
    window.addEventListener("scroll", this.listenerFunction);
  },
  destroyed() {
    window.removeEventListener("scroll", this.listenerFunction);
  },
  filters: {
    filterTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    listenerFunction() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 滚动条滚动时，距离顶部的距离
      this.clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight; // 可视区的高度
      this.scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; // 滚动条的总高度
      if (this.scrollTop + this.clientHeight + 5 >= this.scrollHeight) {
        this.timer = setTimeout(() => {
          //延迟500ms加载数据
          this.pageChange();
        }, 500);
      }
    },
    pageChange() {
      if (this.pagination.pageNum < this.pages) {
        this.pagination.pageNum++;
        this.getNoticeReadRecord();
      } else {
        this.finished = true;
      }
    },
    // tab切换
    changeTab(tab, index) {
      window.scrollTo(0, 0);
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };
      this.pages = 0;
      this.proList = [];
      this.oriProList = [];
      this.tabActive = index;
      this.finished = false;
      this.noticeType = tab.id;
      this.getNoticeReadRecord();
    },
    // 跳转投保前黑名单校验
    async validBlackList(pro) {
      let flag = false;
      await api
        .verifyWhetherVisitorProductPage(this.userId, pro.name)
        .then((res) => {
          if (res.data.returnCode == "0000" && res.data.content == "Y") {
            flag = true;
          } else {
            this.$toast("账号暂无该产品出单权限");
          }
        });
      return flag;
    },
    async goProDetail(pro) {
      const isRead = pro.isRead;
      if (isRead !== "Y") {
        this.addNoticeRead(pro.id);
      }
      if (this.bsMall) {
        // 保思商城逻辑
        // 富文本
      
        if (pro.type == 1 && pro.scope) {
          sessionStorage.setItem('activityDetail', JSON.stringify(pro))
          this.$router.push({
            name: 'activityDetail'
          })
          // this.noticeTitle = pro.noticeTitle;
          // this.richTextContent = pro.scope;
          return;
        }
        // 链接
        if (pro.type == 2 && pro.url) {
          window.location.href = pro.url;
          return;
        }
      } else {
        // 富文本
        if (pro.scope) {
          this.noticeTitle = pro.noticeTitle;
          this.richTextContent = pro.scope;
          this.showRichTextMadal = true;
          return;
        }
        if (pro.noticeMode == "1") {
          // 跳转产品
          if (pro.name) {
            let flag = await this.validBlackList(pro);
            if (!flag) {
              return;
            }
            const productCode = pro.name;
            let url = `/api_wxmall/authority/wxstore/getProductWechatUrl?productCode=${productCode}&mainId=${this.$route.query.coreWxMainId}&userId=${this.userId}`;
            window.location.href = url;
          }
        }
        if (pro.noticeMode == "2") {
          // 跳转链接
          window.location.href = pro.url;
        }
        if (pro.noticeMode == "3") {
          // 跳转图片
          window.location.href = pro.imageUrl;
        }
      }
    },
    // 查询公告标签
    queryLabelList() {
      if (!this.bsMall) {
        this.tabHeadList = [
          { id: "", name: "全部", unreadCount: 0 },
          { id: "10", name: "重要通知", unreadCount: 0 },
          { id: "11", name: "平台通知", unreadCount: 0 },
          { id: "12", name: "产品通知", unreadCount: 0 },
        ];
        this._queryLabel();
        return;
      }
      api
        .queryLabel({
          mainId: this.mainId,
        })
        .then((res) => res.data)
        .then((res) => {
          if (res.returnCode != "0000") {
            this.$toast(res.returnMsg);
            return;
          }
          this.tabHeadList = res.content || [];
          this.tabHeadList.unshift({
            id: "",
            name: "全部",
            unreadCount: 0,
          });
          this._queryLabel();
        });
    },
    // 根据类型查询公告
    getNoticeReadRecord() {
      api
        .queryNoticeByType({
          labelId: this.noticeType,
          mainId: this.mainId,
          userId: this.userId,
          ...this.pagination,
        })
        .then((res) => res.data)
        .then((res) => {
          console.log(res, 142);
          if (res.returnCode != "0000") {
            this.$toast(res.returnMsg);
            return;
          }
          const list = JSON.parse(JSON.stringify(res.content.list));
          this.pages = res.content.pages;
          list.forEach((item) => {
            const index = this.proList.findIndex((p) => p.id == item.id);
            if (index == -1) {
              this.proList.push(item);
            }
          });
          if (this.proList.length == res.content.total) {
            this.finished = true;
          }
        });
    },
    _queryLabel() {
      api
        .unreadNoticeCount({ userId: this.userId, mainId: this.mainId })
        .then((res) => res.data)
        .then((res) => {
          if (res.content) {
            let totalUnreadCount = 0;
            for (let key in res.content) {
              totalUnreadCount += res.content[key];
            }
            this.tabHeadList.forEach((item) => {
              if (item.id) {
                item.unreadCount = res.content[item.id] || 0;
              }
              if (item.name == "全部") {
                item.unreadCount = totalUnreadCount;
              }
            });
          }
        });
    },
    addNoticeRead(id) {
      api
        .addNoticeRead({
          noticeId: id,
          mainId: this.mainId,
          userId: this.userId,
        })
        .then((res) => {
          this.proList.forEach((e) => {
            if (e.id == id) {
              e.isRead = "Y";
            }
          });
          this._queryLabel();
        });
    },
    // 清除未读
    clearAllUnread() {
      api
      .saveAllCoreWxNoticeReadRecord({userId: this.userId})
        .then((res) => res.data)
        .then((res) => {
          if (res.returnCode != "0000") {
            this.$toast(res.returnMsg);
            return;
          }
          this.getNoticeReadRecord();
          this.queryLabelList();
      })
    },
    toLeft() {
      let head = document.getElementById("head");
      let z = head.scrollLeft;
      let scrollWidth = head.scrollWidth;
      let left = Math.abs(z);
      let clientWidth = document.body.clientWidth;
      if (scrollWidth - left - clientWidth < 5) {
        return false;
      }
      head.scrollLeft = z + 60;
    },
  },
};
</script>
<style lang="scss" scoped>
.notice_page {
  width: 100%;
  min-height: 100vh;
  background-color: #f9f9f9;
  position: relative;
  .nomore {
    font-size: 11px;
    color: 838383;
    padding: 10px 0 30px 0;
    box-sizing: border-box;
  }
  .tabs {
    width: 100%;
    overflow: hidden;
    height: 45px;
    background-color: #fff;
    position: sticky;
    background: #fff;
    top: 0;
    left: 0;
    z-index: 10;
    .clear_all {
      position: absolute;
      width: 81px;
      top: 0;
      right: 0;
      height: 45px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666;
      background: #fff;
      z-index: 10;
      .inner {
        height: 16px;
        border-left: 1px solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        img {
        width: 13px;
        margin-left: 8px;
        margin-right: 4px;
      }
      }
     
    }
    ul {
      width: calc(100% - 90px);
      overflow-x: auto;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      margin-left: 0;
      li {
        display: inline-block;
      }
      .empty {
        width: 80px;
        height: 100%;
        .text_tab {
          width: 80px;
        }
      }
    }
    .bg {
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 25%,
        rgba(255, 255, 255, 0) 100%
      );
    }
    .tab_item {
      position: relative;
      color: #373737;
      font-size: 12px;
      padding: 0 7px;
      .text_tab {
        position: relative;
        min-width: 32px;
        p {
          font-family: PingFangSC-Regular;
          font-size: 13px;
        }
      }
      .flex_ {
        display: flex;
        font-size: 0;
      }
      .dot1 {
        position: relative;
        top: -12px;
        font-family: PingFangSC-Regular;
        display: inline-block;
        border-radius: 50%;
        width: 13px;
        height: 13px;
        line-height: 13px;
        text-align: center;
        background: #e83d18;
        font-size: 10px;
        color: #fff;
      }
      .dot2 {
        position: relative;
        top: -12px;
        font-family: PingFangSC-Regular;
        display: inline-block;
        border-radius: 6px;
        padding: 0px 4px;
        height: 13px;
        line-height: 13px;
        text-align: center;
        background: #e83d18;
        font-size: 10px;
        color: #fff;
        vertical-align: middle;
      }
    }
    .on_ {
      p {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
      }
    }
    .bcicle_ {
      position: absolute;
      bottom: -14px;
      left: 50%;
      width: 14px;
      margin-left: -7px;
      display: inline-block;
      height: 4px;
      background: #ff3600;
      border-radius: 2px;
    }
  }
  .pro_list {
    top: 54px;
    left: 0;
    bottom: 0;
    width: 100%;
    .pro_item {
      background-color: #fff;
      padding: 20px;
      margin-top: 8px;

      .title_ {
        position: relative;
        text-align: left;
        color: #373737;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .dot_ {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ff3600;
          margin-left: 3px;
        }
        .top {
          display: inline-block;
          width: 12px;
          height: 13px;
          margin-right: 10px;
          background: url("~@/assets/image/top.png") no-repeat center/12px 13px;
        }
        .title-txt {
          width: 100%;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 1.5;
        }
      }
      .desc_ {
        position: relative;
        font-size: 10px;
        color: #838383;
        line-height: 14px;
        height: 14px;
        text-align: left;
        .content_txt {
          height: 14px;
        }
        .time_ {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}
.modal-content-div {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  font-size: 14px;
  .inner-div {
    position: absolute;
    border-radius: 10px;
    background: #fff;
    width: 86vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: 10px;
    text-align: left;
    .title {
      color: #000;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    .content {
      overflow-y: auto;
      min-height: 80px;
      max-height: 80vh;
      line-height: 22px;
      font-size: 12px;
    }
    .close {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      background: #fff;
      position: absolute;
      left: 50%;
      bottom: -50px;
      text-align: center;
    }
  }
}
</style>
